function createMulti(Klass) {

    return L.FeatureGroup.extend({

        initialize: function (latlngs, options) {
            this._layers = {};
            this._options = options;
            this.setLatLngs(latlngs);
        },

        setLatLngs: function (latlngs) {
            let i = 0;
            const len = latlngs.length;

            this.eachLayer(function (layer) {
                if (i < len) {
                    layer.setLatLngs(latlngs[i++]);
                } else {
                    this.removeLayer(layer);
                }
            }, this);

            while (i < len) {
                this.addLayer(new Klass(latlngs[i++], this._options));
            }

            return this;
        },

        getLatLngs: function () {
            const latlngs = [];

            this.eachLayer((layer) => { latlngs.push(layer.getLatLngs()) });

            return latlngs;
        }
    });
}

L.MultiPolygon = createMulti(L.Polygon);

L.multiPolygon =  (latlngs, options) => { return new L.MultiPolygon(latlngs, options) };